export default function throwRequired(context: string, message: string): never {
  throw new Error(`${context} is missing required property ${message}`)
}
